<template>
  <div class="table_box">
    <el-table
      ref="tableRef"
      :summary-method="getSummaries"
      show-summary
      size="small"
      :data="data"
      border
      :height='tableHeight'
      style="width:100%;"
      class="tabone_sty"
      @row-dblclick="rowdblclick"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'16px',height: '40px'}"
    >
      <el-table-column width="40" align="center" fixed="left" prop="aaaa">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-s-tools" style="color:#2594ff;font-size:18px" @click="clickIcon"></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column fixed="left" label="操作" prop="aaaa" align="center" width="80" v-if="operation">
        <template slot-scope="scope">
          <el-button type="text" size="small" disabled>新增</el-button>
          <el-button type="text" size="small" disabled>移除</el-button>
        </template>
      </el-table-column>
      <template v-for="(item,index) in ConfigData">
        <el-table-column align="center" :label="item.Rename" :prop="item.Key" :key="index" v-if="item.Name == '商品名称' && item.Show == true" fixed="left">
          <template slot-scope="scope">
            <span class="span_inner_sty">{{scope.row[item.Key]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="item.Rename" :prop="item.Key" align="center" :key="index"
          v-if="item.Name != '商品名称' && item.Key != 'PStutas' && item.Show == true" >
          <template slot-scope="scope">
            <span class="span_inner_sty">{{scope.row[item.Key]}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="item.Rename" :prop="item.Key" align="center" :key="index"
           v-if="item.Name != '商品名称' &&  item.Key == 'PStutas' && item.Show == true">
          <template slot-scope="scope">
            <span class="span_inner_sty" v-if="scope.row.PtypeId!==''">{{scope.row[item.Key]=='非赠品'?'非赠品':'赠品'}}</span>
            <span class="span_inner_sty" v-else>{{scope.row[item.Key]}}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <!-- table表格配置弹出框 -->
    <HeaderElastic
      :show.sync="tableConfigShow"
      :tableData="ConfigData"
      v-bind="$attrs"
      v-on="$listeners"
      @restoreDefault="restoreDefault"
    />
    <!-- <TableConfigDialog :show.sync="tableConfigShow" :tableData="ConfigData" v-bind="$attrs" v-on="$listeners" @restoreDefault="restoreDefault"/> -->
  </div>
</template>

<script>
import TableConfigDialog from "../../Dialog/TableConfigDialog/TableConfigDialog.vue"; //table配置弹出框
import tool from "@/utils/tool";

export default {
  // 注册组件
  components: {
    TableConfigDialog, //table配置弹出框
  },
  data() {
    return {
      tableHeight: window.innerHeight*0.625,
      // value: false, //是否启用扫码枪录入商品
      tableConfigShow: false, //配置项弹出框是否显示
      ConfigData: this.tableConfigData, //table配置项数据
      rowIndex: -1, //点击的是第几行
      data:this.tableData,//表格数据项
      // searchData: { title: "", data: {}, type: "" } //传递给选择单价与单位的弹出框,title:弹出框标题、data：传过去的数据、type：类型（单价选择、单位选择）
    };
  },
  props: {
    max: String,
    // Namecommodity:String,
    tableData: Array,
    tableConfigData: Array, //table配置项数据
    // goodsParams: Object //用于传递给商品弹出框列表
    operation:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    // 聚焦选中input全部
    inputFocus() {
      event.currentTarget.select();
    },
    rowdblclick(row) {
      // console.log('-----++>',row);
    },
    //合计方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        
        const values = data.map(item => {
          if (
            column.property == "Qty" ||
            column.property == "Total" ||
            column.property == "AQty" ||

            column.property == "DiscountTotal" ||
            column.property == "WithTaxTotal"||
            // 已下为报表销售统计合计
            // column.property == "AQty"||//订货数量
            column.property == "ATotal"||//订货金额
            column.property == "BQty"||//已收货数量
            column.property == "BTotal"||//已收金额
            column.property == "CQty"||//未收数量
            column.property == "CTotal"||//未收金额
            column.property == "DQty"||//终止数量
            column.property == "DTotal"//终止金额
          ) {
            if (item[column.property] != undefined &&item[column.property]!= '') {
              return this.$attrs.footerMet[column.property];
            }else{
              return Number(0);
            }
          }
        });
        if (!values.every(value => isNaN(value))) {
          sums[index] = this.$attrs.footerMet[column.property];
          sums[index] += "";
        } else {
          // sums[index] = 'N/A';
        }
      });
      return sums;
    },
    //点击图标事件
    clickIcon() {
      this.tableConfigShow = true;
    },
    // 累加数组中的number
    sum(arr) {
        var s = 0;
        for (var i=arr.length-1; i>=0; i--) {
            s += arr[i];
        }
        return Number(s).toFixed(2);
    },
    // 恢复默认回调数据
    restoreDefault(data){
      this.ConfigData = data;
    }
  },
  watch: {
    tableConfigData: {
      handler(newValue, oldValue) {
        this.ConfigData = newValue;
        this.data = this.tableData;
        this.$nextTick(()=>{
          this.$refs.tableRef.doLayout();
        })
      },
      deep: true
    },
    tableData:{
      handler(newValue, oldValue) {
        // console.log(newValue,oldValue);
        this.data = this.tableData;
        this.$nextTick(()=>{
          this.$refs.tableRef.doLayout();
        })
      },
      deep: true
    },
  },
  computed: {},
  mounted() {
    
  }
};
</script>
<style lang="less">
.el-table .cell {
  // overflow: hidden !important;
  white-space: nowrap !important;
  // font-size: 14px;
}
// 引入样式
@import "./TableRead.less";
</style>


// WEBPACK FOOTER //
// src/components/Table/TableRead/TableRead.vue